module.exports = __webpack_public_path__ + "static/media/feb2022.8844ee5d.svg";